import React from 'react'
import classes from './ProgressCard.module.css';

export default function ProgressCard(props) {
    let flexDiv = <div className={[classes.ProgressBarDivStyle, props.clickable && classes.Clickable, props.selected && classes.Selected].join(' ')} onClick={() => props.clickable ? props.onClick() : null} >
        <div className={classes.Percentage}>{props.type === "percentage" ? <p> {props.value} <span className={classes.PercentageSubText}>%</span></p>
            : props.type === "fraction" ? <p>{props.value[0]}<span className={classes.PercentageSubText}> / {props.value[1]}</span></p> : props.value}
        </div>
        <p className={classes.SubTextFlex}>{props.label}</p>
    </div>
    let verticalDiv = <div className={[classes.ProgressBarDiv, props.clickable && classes.Clickable, props.selected && classes.Selected].join(' ')} onClick={() => props.clickable ? props.onClick() : null} >
        <div className={classes.Percentage}>{props.type === "percentage" ? <p> {props.value} <span className={classes.PercentageSubText}>%</span></p>
            : props.type === "fraction" ? <p>{props.value[0]}<span className={classes.PercentageSubText}> / {props.value[1]}</span></p> : props.value}
        </div>
        <p className={classes.SubText}>{props.label}</p>
    </div>
    return (
        props.styleClass === "flex" ? flexDiv : verticalDiv
    )
}
